import * as React from 'react';
import FormElementHook from 'components/form/form-element-hook';
import { FieldType } from './types';
import { Icon } from '@teamsnap/teamsnap-ui';

import './FieldTypeDisplay.scss';

const CreateElement = FormElementHook as new () => FormElementHook;

interface Props {
  field: FieldType;
  formId: number;
  hasLogic: boolean;
  hasFees: boolean;
}

enum FieldLabels {
  email = '123@gmail.com',
  phone = '123-333-3333',
  textarea = 'Text',
  text = 'Text',
}

const getFieldType = (field) => field.type;

const FieldLabel = ({ field }) => (
  <div data-testid={`field-label-${field.id}`}>
    {field.label}
    {field.required && (
      <span data-testid={`field-required-${field.id}`} className="u-colorNegative">
        *
      </span>
    )}
  </div>
);

const FieldTypeDisplay = ({ field, hasFees, hasLogic }: Props) => {

  const FieldTag = ({ text }) => <span data-testid={`${text} Tag`}>{text}</span>;

  const RenderedFieldType = ({ field }) => {
    if (field.type === 'date') {
      return (
        <div className="field-type-display--date">
          <CreateElement
            type="text"
            inputClassName="field-type-display"
            disabled={true}
            label={<FieldLabel field={field} />}
            placeholder="Select Date"
          />
          <Icon name="calendar-today" />
        </div>
      );
    } else if (field.type === 'select' && !field.multiselect) {
      return (
        <CreateElement
          type="select"
          inputClassName="field-type-display"
          disabled={true}
          defaultValue={'Select'}
          options={[{ text: 'Select', value: 'Select' }]}
          label={<FieldLabel field={field} />}
          placeholder="Select"
        />
      );
    } else if (field.type === 'select' && field.multiselect) {
      return (
        <div className="field-type-display--multiselect">
          <span className="label">
            <FieldLabel field={field} />
          </span>
          <div className="field-type-display--multiselect-options">
            {field.options.map((option, i) => (
              <CreateElement
                key={`$${i}-${option}`}
                type="checkbox"
                inputClassName="field-type-display"
                disabled={true}
                label={option}
                placeholder="Select"
              />
            ))}
          </div>
        </div>
      );
    } else if (field.type === 'file') {
      return (
        <div className="field-type-display--multiselect">
          <span className="label">
            <FieldLabel field={field} />
          </span>
          <div className="field-type-display">
            <input type="file" name="fileUpload" disabled />
          </div>
        </div>
      );
    }

    return (
      <CreateElement
        type={getFieldType(field)}
        inputClassName="field-type-display"
        disabled={true}
        label={<FieldLabel field={field} />}
        placeholder={FieldLabels[field.type]}
      />
    );
  };
  return (
    <div className="field-type-display__container">
      <div className="field-type-display__tags">
        {hasLogic && <FieldTag text="Only Show When" />}
        {hasFees && <FieldTag text="Has Fees" />}
      </div>
      <RenderedFieldType field={field} />
    </div>
  );
};

export default FieldTypeDisplay;
